import { BaseRemoteWidgetHandler } from '../common/base-remote-widget-handler';
import { fetchMicrofrontBundle, getMicrofrontNameByWidget, hash } from '../utils';
import { loadBundle } from '@okapi/dom-utils';
import { loadState } from './load-state';
/**
 * Вариация обработчика ремоут компонентов для браузера
 */
export class RemoteWidgetHandler extends BaseRemoteWidgetHandler {
    constructor(serviceDiscoveryClient, headers) {
        super(serviceDiscoveryClient, headers);
        this.sdConfig = window.sdConfig;
    }
    getMicrofrontServer(microfront) {
        var _a, _b, _c, _d, _e;
        return ((_e = (_d = (_b = (_a = this.sdConfig) === null || _a === void 0 ? void 0 : _a[microfront]) !== null && _b !== void 0 ? _b : (_c = this.serviceDiscoveryClient) === null || _c === void 0 ? void 0 : _c.getMicrofrontServer(microfront)) !== null && _d !== void 0 ? _d : this.mfServer) !== null && _e !== void 0 ? _e : '');
    }
    getWidgetHash(widgetData) {
        return hash(widgetData.widget);
    }
    async loadWidget(widgetData, widgetHash) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { widget, id } = widgetData;
        const microfront = getMicrofrontNameByWidget(widget);
        const server = this.getMicrofrontServer(microfront);
        if (!server) {
            return;
        }
        const microfrontBundle = await fetchMicrofrontBundle(server, microfront);
        const mfStyles = (_a = microfrontBundle.styles) !== null && _a !== void 0 ? _a : [];
        const mfScripts = (_b = microfrontBundle.scripts) !== null && _b !== void 0 ? _b : [];
        const widgetStyles = (_e = (_d = (_c = microfrontBundle.resources) === null || _c === void 0 ? void 0 : _c[widget]) === null || _d === void 0 ? void 0 : _d.styles) !== null && _e !== void 0 ? _e : [];
        const widgetScripts = (_h = (_g = (_f = microfrontBundle.resources) === null || _f === void 0 ? void 0 : _f[widget]) === null || _g === void 0 ? void 0 : _g.scripts) !== null && _h !== void 0 ? _h : [];
        const bundle = {
            id,
            widget,
            tagsStore: [],
            state: {},
            html: '',
            scripts: widgetScripts,
            styles: widgetStyles,
            cdnUrl: microfrontBundle.cdnUrl,
        };
        await loadBundle({
            scripts: [...mfScripts, ...widgetScripts],
            styles: [...mfStyles, ...widgetStyles],
            cdnUrl: bundle.cdnUrl,
        });
        return bundle;
    }
    loadState(widget) {
        const microfront = getMicrofrontNameByWidget(widget);
        const server = this.getMicrofrontServer(microfront);
        return loadState({
            server,
            widget,
            headers: this.headers,
            url: window.location.pathname,
        });
    }
}
